import { render } from "./SupplierReportPage.vue?vue&type=template&id=bf7b607c&scoped=true&ts=true"
import script from "./SupplierReportPage.vue?vue&type=script&lang=ts"
export * from "./SupplierReportPage.vue?vue&type=script&lang=ts"

import "./SupplierReportPage.vue?vue&type=style&index=0&id=bf7b607c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf7b607c"]])

export default __exports__